// extracted by mini-css-extract-plugin
export default {"Container":"Poster_Container__DGN5C","wrapper":"Poster_wrapper__U8I4v","poster_1":"Poster_poster_1__rQEhT"};